import React from "react";
import PropTypes from "prop-types";
import text from "../../locales/ru/ru.json";
import "./style.scss";
import BackButton from "../BackButton";
import { useTranslation } from "react-i18next";
export default function ManualGame({ children }) {
  ManualGame.propTypes = {
    children: PropTypes.node,
  };
  const { t } = useTranslation();

  return (
    <div className="manual-wrapper">
      <div className="manual-wrapper__header">
        <div>{t("rules_game.title")}</div>
        <div className="manual-wrapper__header-action">
          <BackButton />
        </div>
      </div>
      <div className="manual-wrapper__manual">
        <div className="manual-wrapper__manual__manual-main">
          <div className="manual-wrapper__manual__tip">
            {t("rules_game.tip")}
          </div>
          <ul className="manual-wrapper__manual__list">
            {text.rules_game.rules.map((rule, index) => {
              return (
                <li key={index} className="manual-wrapper__manual__list__man">
                  <div className="manual-wrapper__manual__list__man__ic">
                    <div className="manual-wrapper__manual__list__man__ic__count">
                      {index + 1}.
                    </div>
                  </div>
                  <span className="manual-wrapper__manual__list__man_highlight highlight">
                    {t(`rules_game.rules.${index}.highlight`)}
                  </span>
                  {t(`rules_game.rules.${index}.desc`)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
